import { ShoppingBag } from "lucide-react";

export default function MoveToCartButton({ product, onMoveToCart }) {
  return (
    <button
      type="button"
      onClick={() => onMoveToCart(product)}
      className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-foreground px-4 py-2.5 text-xs font-black uppercase text-background transition hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-ring"
    >
      <ShoppingBag className="size-4" />
      Move to Cart
    </button>
  );
}